import React, {useState} from 'react';
import {useMutation, useQueryClient} from '@tanstack/react-query';
import {learningService} from '../../services/api';
import {errorText} from './learningUtils';

export default function FileLearningNote({note}) {
  const client = useQueryClient();
  const [saved, setSaved] = useState(false);
  const filing = useMutation({mutationFn: () => learningService.fileSavedNote(note.id), onSuccess: () => {setSaved(true); client.invalidateQueries({queryKey: ['learning']});}});
  const tagged = note.tags?.some(tag => tag.replace(/^#/, '').toLowerCase() === 'learning') || /(?:^|\s)#learning\b/i.test(note.content || '');
  if (!tagged) return null;
  return <div className="mt-3" onClick={event => event.stopPropagation()} onKeyDown={event => event.stopPropagation()}>
    <button disabled={filing.isPending || saved} className="secondary-button" onClick={() => filing.mutate()}>{filing.isPending ? 'Filing…' : saved ? 'Filed into Learning' : 'File into Learning'}</button>
    {filing.data && <p role="status" className="mt-2 text-xs leading-5">{filing.data.confirmation} Your original note is unchanged.</p>}
    {filing.error && <p role="alert" className="mt-2 text-xs text-red-700">{errorText(filing.error)}</p>}
  </div>;
}
